import { useContext } from "react";

import EpisodeContext from "@/containers/Episode/context";
import Button from "@components/Button";
import Typography from "@components/Typography";

import styles from "./UndoRemovedAll.module.css";

const UndoRemovedAll = () => {
  const {
    undoRemoveMention,
    removedMentionIds,
    removedSource,
    show,
    mentions,
  } = useContext(EpisodeContext);

  const oneMention = mentions.length > 1;

  return (
    <div className={styles.root}>
      {removedSource ? (
        <>
          <Typography variant="subtitle-1" className={styles.source}>
            {L.MENTIONS_REMOVED_SOURCE.replace("{show}", show)}
          </Typography>
          <Button
            variant="secondary"
            data-testid="remove-mention-undo"
            onClick={() => undoRemoveMention(removedMentionIds, true)}
          >
            {L.MENTIONS_MARKED_AS_IRRELEVANT_REVERT}
          </Button>
        </>
      ) : (
        <>
          {oneMention ? (
            <>
              <Typography variant="subtitle-1">
                {L.MENTIONS_REMOVED_ALL_MENTIONS}
              </Typography>
              <Button
                variant="secondary"
                data-testid="remove-mention-undo"
                onClick={() => undoRemoveMention(removedMentionIds)}
              >
                {L.MENTIONS_MARKED_AS_IRRELEVANT_REVERT}
              </Button>
            </>
          ) : (
            <>
              <Typography variant="subtitle-1">
                {L.MENTIONS_UNDO_INDIVIDUAL}
              </Typography>
              <Button
                variant="secondary"
                data-testid="remove-mention-undo"
                onClick={() => undoRemoveMention(removedMentionIds)}
              >
                {L.MENTIONS_MARKED_AS_IRRELEVANT_REVERT}
              </Button>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default UndoRemovedAll;
